<template>
    <!-- 新增表格数据的dialog -->
    <div>
        <el-form :model="addForm" ref="addForm" :rules="rules" label-width="120px" label-position="center">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="专题名称" prop="topicName">
                        <el-input v-model.trim="addForm.topicName" placeholder="请输入专题名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="专题颜色" prop="topicColor">
                        <el-color-picker v-model="addForm.topicColor"></el-color-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="专题图片" prop="topicImg">
                <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="quaHandleAvatarSuccess"
                    :on-change="uploadHandleChange"
                    :http-request="handleHttpRequest"
                    :auto-upload="false"
                    style="text-align:left;"
                >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span class="el-upload__tip">温馨提示：建议上传一张宽高比为 4:5 的图片,建议：360px*450px</span>
                </el-upload>
            </el-form-item>
            <el-form-item label="专题描述" prop="topicContent">
                <el-upload
                    class="avatar-uploaders"
                    :action="uploadUrl"
                    name="img"
                    :show-file-list="false"
                    :on-success="contentImgSuccess"
                    :before-upload="BeforecontentImgUpload"
                    style="display:none;"
                >
                    <img v-if="contentImageUrl" :src="contentImageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span class="el-upload__tip">图片地址：{{ contentImageUrl }}</span>
                </el-upload>
                <el-row v-loading="quillUpdateImg">
                    <quill-editor
                        v-model="addForm.topicContent"
                        ref="myQuillEditor"
                        class="editor ql-editor editReset"
                        id="editor"
                        :options="editorOption"
                        @change="onEditorChange($event)"
                        @keydown.native="onEditorKeyDown($event)"
                        @blur="onEditorblur()"
                    ></quill-editor>
                </el-row>
            </el-form-item>

            <div class="dialog-footer">
                <el-button type="info" @click="resetForm('addForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('addForm')">确 定</el-button>
            </div>
        </el-form>
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish">上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
const titleConfig = [
    { Choice: '.ql-bold', title: '加粗' },
    { Choice: '.ql-italic', title: '斜体' },
    { Choice: '.ql-underline', title: '下划线' },
    { Choice: '.ql-header', title: '段落格式' },
    { Choice: '.ql-strike', title: '删除线' },
    { Choice: '.ql-blockquote', title: '块引用' },
    { Choice: '.ql-code', title: '插入代码' },
    { Choice: '.ql-code-block', title: '插入代码段' },
    { Choice: '.ql-font', title: '字体' },
    { Choice: '.ql-size', title: '字体大小' },
    { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
    { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
    { Choice: '.ql-direction', title: '文本方向' },
    { Choice: '.ql-header[value="1"]', title: 'h1标题' },
    { Choice: '.ql-header[value="2"]', title: 'h2标题' },
    { Choice: '.ql-align', title: '对齐方式' },
    { Choice: '.ql-color', title: '字体颜色' },
    { Choice: '.ql-background', title: '背景颜色' },
    { Choice: '.ql-image', title: '图像' },
    { Choice: '.ql-video', title: '视频' },
    { Choice: '.ql-link', title: '添加链接' },
    { Choice: '.ql-formula', title: '插入公式' },
    { Choice: '.ql-clean', title: '清除字体格式' },
    { Choice: '.ql-script[value="sub"]', title: '下标' },
    { Choice: '.ql-script[value="super"]', title: '上标' },
    { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
    { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
    { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
    { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
    { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
    { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
    { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
    { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
    { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
    { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
    { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
    { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
    { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
    { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
    { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
    {
        Choice: '.ql-align .ql-picker-item[data-value="center"]',
        title: '居中对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="right"]',
        title: '居右对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="justify"]',
        title: '两端对齐'
    }
];
const handlers = {};
export default {
    props: ['addData'],
    name: 'FuncFormsEdit',
    components: {
        quillEditor
    },
    data() {
        return {
            content: null,
            quillUpdateImg: false,
            editorOption: {
                theme: 'snow',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
                            ['blockquote', 'code-block'], // 引用，代码块
                            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
                            [{ list: 'ordered' }, { list: 'bullet' }], // 列表
                            [{ script: 'sub' }, { script: 'super' }], // 上下标
                            [{ indent: '-1' }, { indent: '+1' }], // 缩进
                            [{ direction: 'rtl' }], // 文本方向
                            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
                            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
                            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
                            [{ font: [] }], // 字体
                            [{ align: [] }], // 对齐方式
                            ['clean'], // 清除字体样式
                            ['image', 'video']
                        ],
                        handlers: {
                            image: function(value) {
                                if (value) {
                                    // alert(1);
                                    // 用upload的点击事件代替文本编辑器的图片上传事件
                                    document.querySelector('.avatar-uploaders input').click();
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },
            contentImageUrl: '', //详情图片
            // 新增表单数据
            addForm: {
                topicName: '', //专题名称
                topicColor: '', //字体颜色
                topicContent: '', //专题内容
                merchantId: '', //商家ID
                topicImg: '' //Logo图片ID
            },
            // 验证规则
            rules: {
                topicName: [
                    { required: true, message: '请输入专题名称', trigger: 'blur' },
                    { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
                ],
                topicColor: [{ required: true, message: '请选择专题颜色', trigger: 'change' }],
                topicContent: [{ required: true, message: '请输入专题描述', trigger: 'blur' }],
                topicImg: [
                    {
                        required: true,
                        message: '请上传专题图片',
                        trigger: 'change'
                    }
                ]
            },
            uploadUrl: 'upload/fileupload', //图片上传地址
            imageUrl: '',
            option: {
                img: '', // 裁剪图片的地址
                info: false, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 600, // 默认生成截图框宽度
                autoCropHeight: 700, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                // fixedNumber: [5.8, 6], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false,
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            dialogVisible: false, //图片裁剪的弹框dialog
            filename: '' //文件名
        };
    },
    created() {
        this.addForm.merchantId = this.addData;
        console.log(this.addForm.merchantId);
        console.log(this.addData);
    },
    mounted() {
        this.addQuillTitle();
        // 等页面dom元素加载完成后设置富文本编辑框的placeholder
        console.log(document.getElementById('editor'));
        document.getElementById('editor').children[1].children[0].setAttribute('data-placeholder', '请输入专题描述');
    },
    methods: {
        submitForm(formName) {
            //    console.log(tinyMCE.activeEditor.getContent().length);
            //    console.log(tinyMCE.activeEditor.getContent());
            let that = this;
            console.log(that.addForm);
            that.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .post('topic/save', {
                            topicName: that.addForm.topicName,
                            topicColor: that.addForm.topicColor,
                            topicImg: that.addForm.topicImg,
                            topicContent: that.addForm.topicContent,
                            merchantId: that.addData
                        })
                        .then(res => {
                            console.log(res);
                            if (res.data.code == 0) {
                                that.$message.success('新增成功');
                                that.$emit('dialog', false);
                                that.$refs.addForm.resetFields();
                                that.imageUrl = '';
                            } else {
                                that.$message.error(res.data);
                            }
                            console.log(res);
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$refs.addForm.resetFields();
                    this.imageUrl = '';
                    this.$emit('dialog', false);
                })
                .catch(() => {});
        },
        addQuillTitle() {
            console.log(document.getElementsByClassName('ql-editor'));
            document.getElementsByClassName('ql-editor')[0].dataset.placeholder = '';
            for (let item of titleConfig) {
                let tip = document.querySelector('.quill-editor ' + item.Choice);
                if (!tip) continue;
                tip.setAttribute('title', item.title);
            }
        },
        onEditorblur() {},
        // 富文本编辑器的change事件
        onEditorChange({ editor, html, text }) {},
        onEditorKeyDown(event) {},
        handleRemove(file, fileList) {},
        handleAvatarSuccess() {},
        beforeAvatarUploads(file) {},
        quaHandleAvatarSuccess() {},
        quaBeforeAvatarUpload(file) {},
        uploadHandleChange(file) {
            // alert(5)
            this.fileName = file.name;
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            this.$nextTick(() => {
                this.option.img = URL.createObjectURL(file.raw);
                this.dialogVisible = true;
            });
        },
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finish() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.fileName);
                this.handleHttpRequest(file);
                this.dialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async handleHttpRequest(file) {
            let that = this;
            console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(that.uploadUrl, formData, config);
            console.log(res);
            if (res.data.code == 0) {
                that.addForm.topicImg = res.data.data.id;
                that.imageUrl = res.data.data.url;
            } else {
                this.$message.error(res.data);
            }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleClose() {
            this.dialogVisible = false;
        },
        BeforecontentImgUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            let that = this;
            let fd = new FormData(); //通过form数据格式来传
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            fd.append('file', file); //传文件
            fd.append('special', 1);
            that.$axios.post(that.uploadUrl, fd, config).then(function(res) {
                console.log(res.data);
                if (res.data.code == 0) {
                    // that.connectForm.quantityImg = res.data.data.id;
                    that.contentImageUrl = res.data.data.url;
                    //editor对象
                    const quill = that.$refs.myQuillEditor.quill;
                    // 如果上传成功
                    // 获取光标所在位置
                    const length = quill.selection.savedRange.index;
                    // 插入图片  res.info为服务器返回的图片地址
                    quill.insertEmbed(length, 'image', that.contentImageUrl);
                    // 调整光标到最后
                    quill.setSelection(length + 1);
                    that.quillUpdateImg = false;
                } else {
                    this.$message.error(`${res.data.data}`);
                }
            });
        },
        contentImgSuccess() {}
    }
};
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
/deep/.el-input-number .el-input__inner {
    text-align: left;
}
.avatar-uploader {
    display: flex;
    // justify-content: space-around;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: inline-block;
}
.el-select {
    width: 100%;
}
.cropper-content .cropper {
    width: auto;
    height: 300px;
}
.el-upload__tip {
    padding-left: 10px;
    display: inline-block;
}
.el-upload {
    text-align: left !important;
}
</style>
